module.exports = __webpack_public_path__ + "static/media/average-savings@2x.dc6a881e.png";